import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { BsFillTrash3Fill } from "react-icons/bs";

const FilterSearch = (props) => {
  const { t } = useTranslation();
  const [searchShow, setSearchShow] = useState(false);
  const [providerModalShow, setProviderModalShow] = useState(false);
  const [providerSearchValue, setProviderSearchValue] = useState("");
  const [localSelectedProviders, setLocalSelectedProviders] = useState([]);
  const [filterButton1, setFilterButton1] = useState(false); // İlk filtre butonu
  const [filterButton2, setFilterButton2] = useState(false); // İkinci filtre butonu
  const { FilterSearchValue, setFilterSearchValue, games, setProvider, selectedProviders, setSelectedProviders, onFilterButtonsChange } = props;

 
  const handleCloseSearch = () => {
    setSearchShow(false);
    if (setFilterSearchValue) setFilterSearchValue("");
  };

  // Filtre buton durumlarını parent component'e bildir
  useEffect(() => {
    if (onFilterButtonsChange) {
      // Hangi butonun aktif olduğunu gönder: 0 = hiçbiri, 1 = buton1, 2 = buton2
      if (filterButton1) {
        onFilterButtonsChange(1);
      } else if (filterButton2) {
        onFilterButtonsChange(2);
      } else {
        onFilterButtonsChange(0);
      }
    }
  }, [filterButton1, filterButton2, onFilterButtonsChange]);

  // Mobil cihazlarda klavye açıldığında scroll kaymasını önle
  useEffect(() => {
    if (!searchShow) return;

    let initialScrollY = window.scrollY;
    let initialViewportHeight = window.visualViewport?.height || window.innerHeight;

    const handleViewportResize = () => {
      // Viewport height değiştiğinde (klavye açıldığında) scroll pozisyonunu koru
      const currentViewportHeight = window.visualViewport?.height || window.innerHeight;
      
      if (currentViewportHeight < initialViewportHeight) {
        // Klavye açıldı, scroll pozisyonunu koru
        requestAnimationFrame(() => {
          window.scrollTo({
            top: initialScrollY,
            behavior: 'instant'
          });
        });
      }
    };

    const handleScroll = () => {
      // Kullanıcı manuel scroll yaptığında initial pozisyonu güncelle
      if (window.scrollY !== initialScrollY) {
        initialScrollY = window.scrollY;
      }
    };

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleViewportResize);
    } else {
      window.addEventListener('resize', handleViewportResize);
    }
    
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleViewportResize);
      } else {
        window.removeEventListener('resize', handleViewportResize);
      }
      window.removeEventListener('scroll', handleScroll);
    };
  }, [searchShow]);
 
  return (
    <div className="px-2 w-full">
      <div className="flex flex-row  h-[46px] mb-2 mt-2 items-center gap-2 relative">
        {/* Sol taraf - Provider seçim butonu */}
        <div className={`transition-all duration-300 ease-in-out ${searchShow ? 'w-0 opacity-0 overflow-hidden' : 'flex-shrink-0'}`}>
          
        </div>

        {/* Search box - Tam genişlik */}
        <div className={`transition-all duration-300 ease-in-out overflow-hidden ${searchShow
          ? 'flex-1 opacity-100'
          : 'w-full opacity-0 '
          }`}>
          <div className="h-[40px] bg-gray-800 rounded-lg flex items-center gap-2 px-3 relative" style={{ position: 'relative', zIndex: 1 }}>
            <input
              value={FilterSearchValue}
              onChange={(e) => {
                if (setFilterSearchValue)
                  setFilterSearchValue(e.target.value);
              }}
              onFocus={(e) => {
                // Mobil cihazlarda klavye açıldığında scroll kaymasını önle
                const currentScrollY = window.scrollY;
                // Kısa bir gecikme ile scroll pozisyonunu koru
                setTimeout(() => {
                  window.scrollTo({
                    top: currentScrollY,
                    behavior: 'instant'
                  });
                }, 150);
              }}
              type="text"
              className="flex-1 bg-transparent text-white placeholder-gray-400 outline-none"
              placeholder="Oyun Ara"
              autoFocus={searchShow}
            />

            {/* Clear button - Her zaman görünür ve search box'ı kapatır */}
            <button
              onClick={handleCloseSearch}
              className="text-gray-400 hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Sağ taraf - Mercek ikonu ve Grid butonları */}
        <div className={`transition-all duration-300 ease-in-out ${searchShow ? 'w-0 opacity-0 overflow-hidden' : 'flex-shrink-0 flex flex-row gap-1'}`}>
          <button
            onClick={() => {
              // Eğer zaten aktifse pasif yap, değilse aktif yap ve diğerini pasif yap
              if (filterButton1) {
                setFilterButton1(false);
              } else {
                setFilterButton1(true);
                setFilterButton2(false);
              }
            }}
            className={`w-[40px] h-[40px] bg-transparent filterInputIcon border rounded-lg flex items-center justify-center transition-colors ${
              filterButton1 
                ? 'border-blue-500 bg-blue-500/20' 
                : 'border-white/20'
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`w-5 h-5 ${filterButton1 ? 'text-blue-400' : 'text-white'}`}
            >
              {/* 2 sütunlu grid icon */}
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 3h8v8H3V3zm10 0h8v8h-8V3zM3 13h8v8H3v-8zm10 0h8v8h-8v-8z"
              />
            </svg>
          </button>
          <button
            onClick={() => {
              // Eğer zaten aktifse pasif yap, değilse aktif yap ve diğerini pasif yap
              if (filterButton2) {
                setFilterButton2(false);
              } else {
                setFilterButton2(true);
                setFilterButton1(false);
              }
            }}
            className={`w-[40px] h-[40px] bg-transparent filterInputIcon border rounded-lg flex items-center justify-center transition-colors ${
              filterButton2 
                ? 'border-blue-500 bg-blue-500/20' 
                : 'border-white/20'
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`w-5 h-5 ${filterButton2 ? 'text-blue-400' : 'text-white'}`}
            >
              {/* 3 sütunlu grid icon */}
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 3h5v5H3V3zm6 0h5v5H9V3zm6 0h5v5h-5V3zM3 10h5v5H3v-5zm6 0h5v5H9v-5zm6 0h5v5h-5v-5z"
              />
            </svg>
          </button>
          <button
            onClick={() => setSearchShow(!searchShow)}
            className="w-[40px] h-[40px] bg-transparent filterInputIcon border border-white/20 rounded-lg flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5 text-white"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
              />
            </svg>
          </button>
        </div>
      </div>
 
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, permissions, permissionsAll } = authentication;
  const { sports, games, liveGames } = game;
  return {
    user,
    games,
    permissions,
    permissionsAll,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FilterSearch);


const ProviderLogo = {
  "pragmatic": require("../../../assets/img/catalog/fortuna45/pragmatic.png"),
  "evoplay": require("../../../assets/img/catalog/fortuna45/evoplay.png"),
  "egt_digital": require("../../../assets/img/catalog/fortuna45/egt.png"),
  "greentube": require("../../../assets/img/catalog/fortuna45/greentube.png"),
  "habanero": require("../../../assets/img/catalog/fortuna45/habanero.png"),
  "gaminator": require("../../../assets/img/catalog/fortuna45/gaminator.png"),
  "apollo_games": require("../../../assets/img/catalog/fortuna45/apollo_games.png"),
  "spribe": require("../../../assets/img/catalog/fortuna45/spribe.png"),
  "blueprint_gaming": require("../../../assets/img/catalog/fortuna45/blueprint_gaming.png"),
  "playson": require("../../../assets/img/catalog/fortuna45/playson.png"),
  "betsoft": require("../../../assets/img/catalog/fortuna45/betsoft.png"),
  "scientific_games": require("../../../assets/img/catalog/fortuna45/scientific_games.png"),
  "evolution": require("../../../assets/img/catalog/fortuna45/evolution_gaming.png"),
  "egt": require("../../../assets/img/catalog/fortuna45/egt.png"),
  "merkur": require("../../../assets/img/catalog/fortuna45/merkur.png"),
  "novomatic": require("../../../assets/img/catalog/fortuna45/novomatic.png"),
  "booongo": require("../../../assets/img/catalog/fortuna45/booongo.png"),
  "ezugi": require("../../../assets/img/catalog/fortuna45/ezugi.png"),
  "aviatrix": require("../../../assets/img/catalog/fortuna45/aviatrix.png"),
  "yeebet": require("../../../assets/img/catalog/fortuna45/yeebet.png"),
  "ailivecasino": require("../../../assets/img/catalog/fortuna45/ailivecasino.png"),
  "fatpanda": require("../../../assets/img/catalog/fortuna45/fatpanda.png"),
  "pgsoft": require("../../../assets/img/catalog/fortuna45/pgsoft.png"),
  "reelkingdom": require("../../../assets/img/catalog/fortuna45/reelkingdom.png"),
  "toptrendgaming": require("../../../assets/img/catalog/fortuna45/toptrendgaming.png"),
  "goldenrace": require("../../../assets/img/catalog/fortuna45/goldenrace.png"),
  "dreamgaming": require("../../../assets/img/catalog/fortuna45/dreamgaming.png"),
  "worldentertainment": require("../../../assets/img/catalog/fortuna45/worldentertainment.png"),
  "awc": require("../../../assets/img/catalog/fortuna45/awc.png"),
  "ct855(k0)": require("../../../assets/img/catalog/fortuna45/ct855.png"),
  "wmcasino": require("../../../assets/img/catalog/fortuna45/wmcasino.png"),
  "vivo": require("../../../assets/img/catalog/fortuna45/vivo.png"),
  "portomaso": require("../../../assets/img/catalog/fortuna45/portomaso.png"),
  "quickspin": require("../../../assets/img/catalog/fortuna45/quickspin.png"),
  "btg": require("../../../assets/img/catalog/fortuna45/btg.png"),
  "konami": require("../../../assets/img/catalog/fortuna45/konami.png"),
  /* "aviatrix": require("../../../assets/img/catalog/fortuna45/evolution_gaming.png"),
    
    "dreamgaming": require("../../../assets/img/catalog/fortuna45/evolution_gaming.png"),
    "fatpanda": require("../../../assets/img/catalog/fortuna45/evolution_gaming.png"),
    "reelkingdom": require("../../../assets/img/catalog/fortuna45/evolution_gaming.png"),
    "playson": require("../../../assets/img/catalog/fortuna45/evolution_gaming.png"),
  */
}